import React from 'react';

import './index.css';

const FormOverlay = ({ children, onHide }) => {
    return (
        <div>
            <div className="modal-overlay" onClick={onHide}></div>
            <div className="modal-content">
                {children}
            </div>
        </div>
    );
}

export default FormOverlay;


// WEBPACK FOOTER //
// ./src/components/Modal/index.js